import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPropertyImageUrl } from "../../services/propertyImagesApi";

export const fetchPropertyImage = createAsyncThunk(
  "propertyImages/fetchPropertyImage",
  async ({ hostId, propertyId, propertySource }, { rejectWithValue }) => {
    try {
      console.log('Redux thunk: Fetching image for property:', { hostId, propertyId, propertySource });
      const imageUrl = await getPropertyImageUrl(hostId, propertyId, propertySource);
      console.log('Redux thunk: Got image URL:', imageUrl);
      return { propertyId, imageUrl };
    } catch (error) {
      console.error('Redux thunk: Error fetching image:', error);
      return rejectWithValue(error.message);
    }
  }
);